import React from 'react';
import { Ear, Puzzle, Sparkles } from 'lucide-react';
export function ProgramExplanation() {
  const phases = [{
    icon: Ear,
    title: 'Fase 1: Reconoce el sonido',
    desc: 'Aprende a escuchar y distinguir los sonidos del lenguaje'
  }, {
    icon: Puzzle,
    title: 'Fase 2: Une sonido con forma',
    desc: 'Conecta cada sonido con su letra de forma natural'
  }, {
    icon: Sparkles,
    title: 'Fase 3: Forma su primera palabra',
    desc: 'La lectura emerge como resultado, no como esfuerzo'
  }];
  return <section className="w-full bg-cream-dark py-20 md:py-28 px-4" data-id="element-121">
      <div className="max-w-5xl mx-auto text-center mb-16" data-id="element-122">
        <h2 className="text-3xl md:text-4xl font-bold text-dark mb-6" data-id="element-123">
          ¿Qué pasa exactamente en esos 10 minutos?
        </h2>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-124">
        {phases.map((phase, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group" data-id="element-125">
            <div className="absolute top-0 left-0 w-full h-1 bg-olive" data-id="element-126"></div>
            <div className="w-12 h-12 bg-cream rounded-full flex items-center justify-center mb-6 group-hover:bg-olive/10 transition-colors" data-id="element-127">
              <phase.icon className="w-6 h-6 text-olive" data-id="element-128" />
            </div>
            <h3 className="text-xl font-bold text-dark mb-3 font-serif" data-id="element-129">
              {phase.title}
            </h3>
            <p className="text-dark/70 leading-relaxed" data-id="element-130">{phase.desc}</p>
            <div className="absolute -bottom-10 -right-10 w-24 h-24 bg-olive/5 rounded-full" data-id="element-131"></div>
          </div>)}
      </div>

      <div className="max-w-3xl mx-auto text-center space-y-10" data-id="element-132">
        <p className="text-xl md:text-2xl text-terracotta font-serif italic" data-id="element-133">
          "No empieza leyendo. Empieza jugando con sonidos hasta que la lectura
          aparece sola."
        </p>

        <button onClick={() => window.open('https://www.gaiadigitalpro.com/checkouts/cn/hWN91detKUA3JZvySec9CenJ/es-ar?_r=AQABrOvx_mroREqaZDGTff6UkVA7_iuSpYNGcQFEgzuoo40&preview_theme_id=163059597347', '_blank')} className="hover:bg-terracotta-light text-white font-serif text-lg px-10 py-4 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 bg-[#6FC628]" data-id="element-134">
          Quiero acompañarlo correctamente
        </button>
      </div>
    </section>;
}